import { type ReactElement } from "react";

// The "total + per-status" rows of an overview counts table — one copy of the
// shape (and of the snake_case → words decode) shared by the admin and
// collaborator overviews. Renders bare <tr> rows; the caller owns the <table>.
// The total is the section row; the per-status breakdown nests under it
// (indented `.sub` labels, right-aligned `.num` counts).
export function StatusCountRows({
  label,
  total,
  byStatus,
}: {
  label: string;
  total: number;
  byStatus: Record<string, number>;
}): ReactElement {
  return (
    <>
      <tr className="section">
        <th scope="row">{label}</th>
        <td className="num">{total}</td>
      </tr>
      {Object.entries(byStatus).map(([status, count]) => (
        <tr key={status}>
          <th scope="row" className="sub muted">
            {status.replaceAll("_", " ")}
          </th>
          <td className="num">{count}</td>
        </tr>
      ))}
    </>
  );
}
